import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import lang from '@/lang'

import SupplierService from '@/modules/supplier/supplierService'
import SupplierAddressFormModal from '../edit/forms/address/address-form-modal'
import SelectInput from '@/modules/base/components/inputs/select-input/select-input'
import { openAddressFormModal, resetState, closeAddressFormModal } from '@/redux/ducks/supplier/edit'
import { SUBSCRIPTION_MODULES } from '@/modules/base/util/constants'
import { checkModuleAccess } from '@/modules'

async function fetchSupplier(searchTerm, loadedOptions) {
  try {
    const offset = loadedOptions?.length || 0
    const { data: suppliers, meta: { count } } = await SupplierService.find(searchTerm, offset, 10)

    const selectOptions = suppliers.map(supplier => {
      const { id, name } = supplier
      return {
        value: id,
        label: name,
        supplier,
      }
    })

    const hasMore = (offset + selectOptions.length) !== count

    return {
      options: selectOptions,
      hasMore,
    }
  } catch (error) {
    console.error(error)
  }
}

export function SupplierSelect(props) {
  const dispatch = useDispatch()
  const { onAdd, onChange, isMulti, ...restProps } = props
  const open = useSelector(state => state.supplier.edit.addressFormModalOpen)

  const allowCreate = Boolean(onAdd)

  const options = {
    infiniteScroll: true,
    allowCreate,
    customSelectOptions: {
      isClearable: false,
      escapeClearsValue: true,
      hideSelectedOptions: false,
      placeholder: lang.selectInput.supplier.placeholder(allowCreate),
      defaultMenuIsOpen: false,
      defaultOptions: true,
      loadOptions: fetchSupplier,
      loadingMessage: lang.selectInput.supplier.loadingMessage,
      isMulti,
    },
    useFormik: false,
  }

  const handleSupplierAdd = (name) => {
    dispatch(resetState())
    dispatch(openAddressFormModal({ companyName: name }))
  }
  const handleAddressSubmit = (addresses) => {
    dispatch(closeAddressFormModal())
    onAdd && onAdd(addresses)
  }

  const handleSupplierChange = (option) => {
    onChange && onChange(option)
  }

  const handleAbort = () => {
    dispatch(closeAddressFormModal())
  }

  const addressFormModal = open
    ? (
      <SupplierAddressFormModal
        onSubmit={handleAddressSubmit}
        onCancel={handleAbort} />
    )
    : null

  return checkModuleAccess(SUBSCRIPTION_MODULES.SUPPLIERS)
    ? (
      <>
        <SelectInput
          {...restProps}
          {...options}
          onOptionCreated={handleSupplierAdd}
          handleChange={handleSupplierChange} />
        {addressFormModal}
      </>
    )
    : null
}
